<template>
  <v-layout column v-scroll="onScroll">
    <section>
      <v-carousel lazy>
        <v-carousel-item v-for="(item, i) in bannerImg" :src="i !== 0 ? item.src : 'https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_1024/site/1'" :key="i">
          <v-layout
            column
            align-center
            justify-center
            class="white--text"
            v-if="i === 0"
          >
            <h1 class="white--text mb-2 display-1 text-xs-center">Institute of Computer Studies</h1>
            <div class="subheading mb-3 text-xs-center">The technological institute of Western Mindanao State University</div>
            <v-btn
              class="green darken"
              dark
              large
              round
              to="/about"
            >Know us more</v-btn>
          </v-layout>
          <v-layout
            column
            align-center
            justify-center
            class="white--text"
            v-else
          >
            <div class="border-box text-xs-center">
              <h1 class="white--text mb-2 display-1 text-xs-center">{{ item.title }}</h1>
              <div class="subheading mb-3 text-xs-center">{{ item.content.substr(0,100) + '...' }}</div>
              <v-btn :to="'/news/' + item.newsId" class="green darken" dark>Read more</v-btn>
            </div>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
    </section>
    <section>
      <v-container grid-list-lg>
        <v-layout row wrap justify-center align-center class="my-5">
          <v-flex class="text-xs-center" xs12 md6>
            <router-link to="/director">
              <img src="http://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_500/site/director-corner.png" alt="">
            </router-link>
            <!-- <h1 class="headline layout justify-center mb-3">Latest News</h1>
            <div style="overflow-y: scroll; height: 300px;" v-if="newsData.length !== 0">
              <v-card class="mb-3" v-for="news in newsData" :key="news.news_id">
                <v-card-media src="/static/img/resources/2.jpg" height="200px"></v-card-media>
                <v-card-title primary-title>
                  <div class="headline mb-0">{{ news.news_title }}</div>
                </v-card-title>
                <v-card-text>
                  <p class="subheading">by: {{ `${news.author.given_name} ${news.author.family_name}` }}</p>
                  <p>{{ news.news_content }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat color="orange">Link</v-btn>
                </v-card-actions>
              </v-card>
            </div>
            <h1 class="subheading text-xs-center" v-if="newsData.length === 0">No new articles</h1> -->
          </v-flex>
          <v-flex sm12 md6>
            <div class="headline text-xs-center">Calendar of Activities</div>
            <v-layout row>
              <v-flex xs12>
                <router-link to="/calendar" style="text-decoration: none;">
                  <v-list two-line class="grey lighten-2" v-if="events.length !== 0" style="max-height: 300px; overflow-y: scroll;">
                    <template v-for="(item, index) in events">
                      <v-list-tile avatar v-bind:key="index">
                        <v-list-tile-content >
                          <v-list-tile-title >{{ item.start_date }} - {{ item.end_date }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ item.name }}</v-list-tile-sub-title>
                          <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider :key="'0' + index"></v-divider>
                    </template>
                  </v-list>
                </router-link>
                <h1 class="subheading text-xs-center" v-if="events.length === 0">No events for this month</h1>
              </v-flex>
            </v-layout>
                
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section>
      <v-parallax class="banner-img" src="https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_1024/site/2" height="300">
        <v-layout
          column
          align-center
          justify-center
          class="white--text"
        >
          <div class="headline text-xs-center">Take part of this stronghold institution.</div>
          <!-- <v-btn
            class="green darken mt-3"
            dark
            large
            round
          >Join us</v-btn> -->
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-lg>
        <v-layout row wrap justify-center class="my-5">
          <v-flex sm12 md4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">About the Institute</div>
              </v-card-title>
              <v-card-text>
                Institute of Computer Studies is a stronghold Institute in Western Mindanao State University, offering quality education in the field of computer science and technology. Be proud and take part of this remarkable Institute.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Contact us</div>
              </v-card-title>
              <v-list class="transparent">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="green--text">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>777-867-5309</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="green--text">place</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title >Normal Road, Baliwasan, Zamboanga City, Philippines</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <!-- <v-icon class="green--text text--lighten-2">email</v-icon> -->
                    <v-icon class="green--text">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>ics@wmsu.edu.ph</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex sm12 md4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Find us!</div>
              </v-card-title>
              <v-card-text>
                <gmap-map
                    :center="{ lat: 6.913909, lng: 122.061529 }"
                    :zoom="17"
                    style="height: 300px;"
                    :draggable="false"
                  >
                    <gmap-marker
                      :position="{ lat: 6.913909, lng: 122.061529 }"
                    ></gmap-marker>
                </gmap-map>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>


    <v-fab-transition>
      <v-btn
        color="yellow darken-2"
        dark
        fixed
        bottom
        right
        fab
        v-show="floatingButton"
        v-scroll-to="'body'"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data () {
    return {
      floatingButton: false,
      events: [],
      newsData: [],
      bannerImg: [
        { src: '/static/img/resources/1.jpg' }
      ]
    }
  },
  created(){
    
    axios.get('/api/calendar').then(events => {
      // this.events = events
      let formattedDate = events.data.map(event => {
        event.start_date = moment(event.start_date).format('MMM D')
        event.end_date = moment(event.end_date).format('MMM D')
        return event
      })
      this.events = formattedDate
    })

    axios.get('/api/news').then(news => {
      this.newsData = news.data
      news.data.filter(newsData => {
        if(newsData.image_url)
          return newsData
      }).map(mapItem => {
        this.bannerImg.push({
          src: mapItem.image_url,
          title: mapItem.news_title,
          content: mapItem.news_content,
          newsId: mapItem.news_id
        }) 
      })
    })
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return

      const top = window.pageYOffset ||
        document.documentElement.offsetTop ||
        0

      this.floatingButton = top > 150
    }
  }
}
</script>

<style scoped>
.border-box{
  background-color: rgba(0, 0, 0, 0.4);
  padding: 20px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Index.vue